import React from 'react'
import { Spinner } from 'react-bootstrap'

export const SubmitBtn = ({ type, customClassName, customStyles, onClick, loading, title = "Submit", disabled }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={loading || disabled}
      className={`btn btn-default ${customClassName}`}
      style={{ cursor: 'pointer', ...customStyles }}
    >
      {
        loading ? <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
          : title
      }
    </button>
  )
}
